import { colors } from '@flowwai-frontend/shared/style-guide'

export const pipelineSettingsThemes = {
   light: {
      common: {
         sectionDividerColor: 'border-t-gray-300 bg-gray-300',
         activeTabIconColor: colors['primary-600'],
         tabIconColor: colors['gray-400'],
         defaultBgColor: 'bg-gray-100'
      },
      header: {
         titleColor: 'text-gray-900',
         borderColor: 'border-b-gray-300',
         backgroundColor: 'bg-white',
         refreshIconBg: '!bg-white',
         refreshIconColor: colors['gray-700']
      },
      bodyCard: {
         bodyBgColor: 'bg-gray-100',
         cardBorderColor: 'border-gray-300',
         cardBgColor: 'bg-white',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600'
      },
      detailsCard: {
         cardBorderColor: 'border-gray-300',
         sectionDividerColors: 'bg-gray-300 border-t-gray-300',
         labelColors: 'text-gray-500',
         valueColors: 'text-gray-800'
      },
      fields: {
         advancedAnalyticsFieldLabelColor: 'text-gray-700',
         advancedAnalyticsFieldDescriptionColor: 'text-gray-600',
         whatsappConsentStatusLabelColor: 'text-gray-700',
         whatsappConsentStatusDescriptionColor: 'text-gray-600',
         defaultToggleSwitchBgColor: colors['gray-100']
      },
      stageTransitionStyle: {
         selectedBorderColor: 'border-primary-600',
         unSelectedBorderColor: 'border-gray-300',
         selectedTextColor: 'text-primary-600',
         hintTextColor: 'text-gray-600',
         labelTextColor: 'text-gray-700'
      }
   },
   dark: {}
}
